var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3417",
    "data-name": "Group 3417",
    transform: "translate(0 0.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2265",
    "data-name": "Rectangle 2265",
    transform: "translate(0 -0.047)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 62.5,
    height: 62.5,
    rx: 4.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "phone-call-svgrepo-com",
    d: "M25.661,3.426a12.475,12.475,0,0,1,7.412,3.706,12.475,12.475,0,0,1,3.706,7.412M24.735,9.912a7.194,7.194,0,0,1,3.706,1.853,7.194,7.194,0,0,1,1.853,3.706M13.062,27.142C.281,14.359,2.1,8.506,3.446,6.619c.173-.3,4.439-6.691,9.013-2.944,11.351,9.349-2.547,9.016,6.513,17.56s8.212-4.839,17.559,6.51c3.747,4.575-2.64,8.841-2.943,9.012C31.7,38.107,25.846,39.925,13.062,27.142Z",
    transform: "translate(11 11)",
    fill: "none",
    stroke: "#0ab8e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5a25b17fc5d05dcde31707f5c476cc01.svg";
export { ForwardRef as ReactComponent };